module.exports = __webpack_public_path__ + "static/ucc-logo-42f90c061d96a5b04a64a297fa39f896.png";